import { render, staticRenderFns } from "./ResponseComponent.vue?vue&type=template&id=a3800dac&"
import script from "./ResponseComponent.vue?vue&type=script&lang=js&"
export * from "./ResponseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports